import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { deviceLogFolderFiles } from './queryKeys';
import envVars from '../../../../constants/envVars';
import useQueryRequestParams from '../../../../hooks/useQueryRequestParams';
const useGetDeviceLogFolderFiles = (props, enabled) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryFn: () => axios.get(`${envVars.API_CLOUD_HOSTNAME}backoffice/logs-on-demand/files/`, {
            ...additional,
            params: { ...props }
        }),
        queryKey: [deviceLogFolderFiles, props.device_id, props.folder],
        enabled,
        refetchOnWindowFocus: false
    });
};
export default useGetDeviceLogFolderFiles;
